module.exports = __webpack_public_path__ + "img/anamaria-barloiu.33e35255.jpg";